import { useSelector } from 'react-redux';
import { useMemo, useState } from 'react';
import { ApplicationState } from '@mews-commander/types';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { AssociateCurrentOwnerContext, BillingModeContext, SelectedAccountIdsContext } from '../context';
import { ItemAssignmentDialogContentCompany } from './ItemAssignmentDialogContentCompany';
import { ItemAssignmentDialogContentCustomer } from './ItemAssignmentDialogContentCustomer';
import { ItemAssignmentDialogContentOwnProps } from './types';

export const ItemAssignmentDialogContent = (props: ItemAssignmentDialogContentOwnProps) => {
    const [selectedAccountId, setSelectedAccountId] = useState<string>('');
    const [associateCurrentOwner, toggleAssociateCurrentOwner] = useState<boolean>(true);

    const { accountIds, billingMode } = props;

    const isBillingOwnerCompany = useSelector((state: ApplicationState) =>
        isAccountIdCompany(state, { accountId: accountIds[0] })
    );

    const selectedAccountIdsContextValue = useMemo(
        () => ({
            selectedAccountId,
            setSelectedAccountId,
            billingOwnerId: accountIds[0],
        }),
        [selectedAccountId, setSelectedAccountId, accountIds]
    );

    const DialogToRender = isBillingOwnerCompany
        ? ItemAssignmentDialogContentCompany
        : ItemAssignmentDialogContentCustomer;

    return (
        <BillingModeContext.Provider value={billingMode}>
            <AssociateCurrentOwnerContext.Provider value={{ associateCurrentOwner, toggleAssociateCurrentOwner }}>
                <SelectedAccountIdsContext.Provider value={selectedAccountIdsContextValue}>
                    <DialogToRender {...props} />
                </SelectedAccountIdsContext.Provider>
            </AssociateCurrentOwnerContext.Provider>
        </BillingModeContext.Provider>
    );
};
